import ApiServer from "../../ApiServer.js";
import ISharableByMember from "./ISharableByMember.js";
import * as i18n from "../../i18n.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Sorting from "../../lib/Sorting.js";
import * as Locale from "../../util/Locale.js";
import * as amplify from "../../util/amplify.ts";
import {SyncCache,ListCache, MetaCache4} from "../../lib/SyncCache.ts";
import {recipeSyncCache} from "../../mealplanner/mealplannerApi.ts";
import IHasRecurrencyHelper from "../../lib/IHasRecurrencyHelper.js";
import * as deltatime from "../../lib/deltatime.js";
import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

import TPL_TASKLIST_EMPTY_TODO from "../../list/tasklist-empty-todo.mustache";
import TPL_TASKLIST_EMPTY_SHOPPING from "../../list/tasklist-empty-shopping.mustache";
import TPL_TASKLIST_EMPTY_OTHER from "../../list/tasklist-empty-other.mustache";
import TPL_TASKLIST_EMPTY_CLEARED from "../../list/tasklist-empty-cleared.mustache";

import {mustache,SafeString} from "../../handlebars_family.js";

function completeSorter(a,b){
  if(a.complete===b.complete){
    return 0;
  }
  return a.complete?1:-1;
}
const TASK_SORTER = {
    
    alphabetical:Sorting.composedSorter(completeSorter,function(a,b){
      return a.text.localeCompare(b.text)
    }),
    alphabeticalReverse:Sorting.composedSorter(completeSorter,function(a,b){
      return b.text.localeCompare(a.text)
    }),
    creationdate:Sorting.composedSorter(completeSorter,function(a,b){
      return b.creationDate - a.creationDate;
    }),
    creationdateReverse:Sorting.composedSorter(completeSorter,function(a,b){
      return a.creationDate - b.creationDate;
    }),
    duedate:Sorting.composedSorter(completeSorter,function(a,b){
      return (b.dueDate||0) - (a.dueDate||0);
    }),
    duedateReverse:Sorting.composedSorter(completeSorter,function(a,b){
      return (a.dueDate||0) - (b.dueDate||0);
    }),
    modifDate:Sorting.composedSorter(completeSorter,function(a,b){
      return (b.modifDate||0) - (a.modifDate||0);
    }),
    byrecipe:Sorting.composedSorter(completeSorter,function(a,b){
      let 
        aRef = a.refObject(),
        bRef = b.refObject();
      //if no refAt all or same ref
      if(aRef===bRef){
        return a.text.localeCompare(b.text);
      }
      if(aRef===undefined){
        return 1;
      }
      if(bRef===undefined){
        return -1;
      }
      //if same ref name fallback to task name compare
      if(aRef.name===bRef.name){
        return a.text.localeCompare(b.text);
      }
      return aRef.name.localeCompare(bRef.name);
    }),
    byrecipeReverse:Sorting.composedSorter(completeSorter,function(a,b){
      return TASK_SORTER.byrecipe(b,a);
    }),
    
    custom:Sorting.composedSorter(completeSorter,function(a,b){
      return b.sortingIndex - a.sortingIndex;
    })
}

var emojiRegexp;
try{
  emojiRegexp = new RegExp('^\\p{RGI_Emoji}$','v');
}catch(e){
  console.log(e)
}

function decodeHasEmoji(obj){
  //the syntax of regexp with / make webpack explode
  if(emojiRegexp===undefined || emojiRegexp.test(obj.emoji)){
    obj.emojiValid = obj.emoji;
  }
}
Object.assign(ApiServer.types.ITaskList.prototype,ISharableByMember)
Object.assign(ApiServer.types.ITaskList.prototype,{
  onDecode:function(json){
    //first of get transient data like is the list opened
    this.rights.canShare = this.accountId === FwDatas.getUser().accountId;
    this.sharingType = this.sharedToAll?'all':(this.sharedMemberIds.length>1?'custom':'none')
    decodeHasEmoji(this);

    if(this.systemId){
      if(this.name==='SYS-CAT-TODOS'){
        this.name = i18n.get('catsystem.SYS-CAT-TODOS');
      }else if(this.name==='SYS-CAT-SHOPPINGLIST'){
        this.name = i18n.get('catsystem.SYS-CAT-SHOPPINGLIST');
      }
      this.system = true;
      this.rights.canUpdate = true; //20230105 now we can update a part of the List
    }    
    if(this.taskListType==='TODOS'){
      this.iconsimple = Icons.list.ic_list_item_type_todo;
    }else if(this.taskListType==='SHOPPING_LIST'){
      this.iconsimple = Icons.list.ic_list_item_type_groceries;
    }else{
      this.iconsimple = Icons.ic_list;
    }
    if(this.color===undefined) {
      this.color = FizConfig.defaultColor;       
    }
    this.wallKey = this.lastAction==="UPDATED"?"notifications.TASKLISTUPDATED":"notifications.TASKLISTCREATED";
    this.members = this.sharedMembers();
    this.firstMedia = this.medias&&this.medias.length?this.medias[0]:null;
    
    //TODO replace complete/all/ongoing by getter that dig the datas
    let 
      oldList = FwDatas.get(this.metaId);
    if(oldList){
      this.closed = oldList.closed;
      this.complete = oldList.complete;
      this.all = oldList.all;
      this.ongoing = oldList.ongoing;
    }else{
      this.complete = [];
      this.all = [];
      this.ongoing = [];
    }
    FwDatas.cache(this);
    
  },
  dispatchTasks(){
    this.complete = [];
    this.all = [];
    this.ongoing = [];
    TaskCache.datas.forEach(task=>{
      if(task.taskListId===this.metaId){
        
        task.color = this.color;
        this.all.push(task);
        if(task.computedComplete){
          this.complete.push(task);
        }else{
          this.ongoing.push(task);
          this.overDue |= task.overDue;
        }
        task.list=this;
      }
    });
    this.sort();
  },
  tplEmpty:function(){
    if(this.all.length===0){
      if(this.taskListType==='TODOS'){
        return new SafeString(mustache(TPL_TASKLIST_EMPTY_TODO,this));
      }else if(this.taskListType==='SHOPPING_LIST'){
        return new SafeString(mustache(TPL_TASKLIST_EMPTY_SHOPPING,this));
      }else if(this.taskListType==='OTHER'){
        return new SafeString(mustache(TPL_TASKLIST_EMPTY_OTHER,this));
      }
    }else if(this.ongoing.length===0 && this.complete.length && this.completedHidden){
      return new SafeString(mustache(TPL_TASKLIST_EMPTY_CLEARED,this));
    }
  },
  taskByCategory:function(){
    let 
      result = [{
          category:new ApiServer.types.TaskCategoryBean({
            emoji:'🏷️',
            metaId:"",
            name:i18n.get('catsystem.uncategorized'),
            sortingIndexByTaskList:{},
            initialSortingIndex:1000000000000,
            isOpen:true
          }),
          items:[]
        }].concat(this.getCategories().map(cat=>{return {category:cat,items:[]}})),
      itemsByCatid = {};
    result.forEach(group=>itemsByCatid[group.category.metaId]=group.items)  
      
    this.all.forEach(task=>{
      if(this.completedHidden && task.complete) return;
      if(itemsByCatid[task.taskCategoryId]==undefined){
        itemsByCatid[""].push(task)
      }else{
        itemsByCatid[task.taskCategoryId].push(task);
      }
    })
    result = result.filter(catdesc=>catdesc.items.length>0)
    //force to sort again for the uncategorized items
    result.sort(Sorting.levelSorter(a=>{
      return a.category?(a.category.sortingIndexByTaskList[this.metaId]||a.category.initialSortingIndex):0;
    }));
    
    
    result.forEach(catitem=>catitem.items.sort(TASK_SORTER[this.taskSorting]));
    return result;
  },
  i18ncomplete : function(){
    return this.complete.length===1?i18n.get('task_details.complete'):i18n.get('task_details.completeN',this.complete.length)
  },
  sortCartridge:function(){
    if(this.taskSorting==='custom') return;
    let 
      isUp = this.taskSorting.indexOf('Reverse')===-1,
      reverse = {
        "alphabetical":"alphabeticalReverse",
        "alphabeticalReverse":"alphabetical",
        "duedate":"duedateReverse",
        "duedateReverse":"duedate",
        "creationdate":"creationdateReverse",
        "creationdateReverse":"creationdate",
        "byrecipe":"byrecipeReverse",
        "byrecipeReverse":"byrecipe"
      }[this.taskSorting];
    
    return {
      name:  i18n.get('catsystem.sortedby.'+this.taskSorting),
      reverseonclick: 'tasklistsort|'+reverse,
      up:isUp
    }
  },
  mightsort:function(){
    if(this.ongoing.length>1||this.complete.length>1){
      return {
          alphabetical:true,
          creationdate:true,
          custom:true,
          byrecipe:this.all.filter(task=>task.refObject()!==undefined).length>0,
          duedate:this.all.filter(task=>task.dueDate!==undefined).length>0,
      }
    }
  },
  getCategories(localeFilter = false){
    var
      locale = Locale.get().substring(0,2),
      metaId = this.metaId,
      filterCategories = {
        TODOS:function(cat){return cat.taskListType==='TODOS'},
        SHOPPING_LIST:function(cat){return cat.taskListType==='SHOPPING_LIST'},
        OTHER:function(cat){return cat.taskListType==='OTHER' && cat.filterTasklistId===metaId}
      }[this.taskListType],
      categories = TaskCategoryCache.datas
        .filter(filterCategories)
        .filter(cat=>cat.hiddenByTaskList.indexOf(metaId)===-1);
        
    if(localeFilter){
      categories = categories.filter(cat=>(cat.locale===locale || !cat.locale));
    }    
    
    categories.sort((a,b)=>{
      return a.sortingIndexByTaskList[metaId]-b.sortingIndexByTaskList[metaId];
    })
    return categories
  },
  sort:function(){
    this.ongoing.sort(TASK_SORTER[this.taskSorting])
    this.complete.sort(TASK_SORTER[this.taskSorting])  
  }
})

Object.assign(ApiServer.types.TaskBean.prototype,{
  listInterval(range,extra=0){
    //we change the range because 0 needed to compute well if it is completed
    let instanceUntil = IHasRecurrencyHelper.listInterval(this, range,extra+2);
    this.rights = this.editable?{canDelete:true,canUpdate:true}:{canDelete:false,canUpdate:false}
    //first of all we set the attribute well
    for(let i=0;i<instanceUntil.length;i++){
      let 
        loopTask = instanceUntil[i];
      loopTask.computedDueDate = loopTask.start;
    }
    if(this.recurrencyDescriptor.rrule){
      //then we compute the "complete" per instance 
      for(let i=0;i<instanceUntil.length-1;i++){
        let 
          loopTask = instanceUntil[i],
          next = instanceUntil[i+1];
        if(!this.completedDate){
          loopTask.computedComplete = false;
          next.computedComplete = false;
        }else if(this.completedDate>=loopTask.computedDueDate){
          loopTask.computedComplete = true;
          next.computedComplete = true;
        }else{
          if(i===0)loopTask.computedComplete = true;
          next.computedComplete = false;
        }
      }
      //now we try to find the "main" task the one which will appears in the list and which is markable
      for(let i=0;i<instanceUntil.length;i++){
        let loopTask = instanceUntil[i];
        if(loopTask.start>new Date()){
          if(i>0 && !instanceUntil[i-1].computedComplete){
            instanceUntil[i-1].maintask = true;
          }else{
            loopTask.maintask = true;
          }
          break;
        }
      }
      for(let i=0;i<instanceUntil.length;i++){
        let loopTask = instanceUntil[i];
        if(!loopTask.maintask){
          loopTask.editable = false;
          loopTask.uncheckable = true;
        }
      }
    }
    
    
    instanceUntil.forEach(taskInstance=>{
      if(taskInstance.computedComplete){
        taskInstance.title = '☑ '; //title for calendar.js
      }else{
        taskInstance.title = '☐ '
      }
      if(taskInstance.recurrencyDescriptor.rrule){
        taskInstance.title += '↺ ';
      }
      taskInstance.title += taskInstance.text;

      taskInstance.overDue = !taskInstance.computedComplete && taskInstance.computedDueDate<new Date();
      FwDatas.cache(taskInstance)
    })
    
    return instanceUntil;
  },
  refActionData:function(){
    if(this.lastAction==='MARK_COMPLETED'){
      return {text:i18n.get('refAction.completed'),author:FwDatas.getProfile(this.lastActionAuthor),date:this.lastActionDate};
    }else if(this.lastAction==='UPDATED'){
      return {text:i18n.get('refAction.updated'),author:FwDatas.getProfile(this.lastActionAuthor),date:this.lastActionDate};
    }
  },
  onDecode:function(json){
    //some data from server appear to not have text (but just an url as description)
    if(!this.text){
      this.text= '  '
    }
    for(var ii=0;ii<this.assignee.length;ii++){
      this.assignee[ii] = FwDatas.getProfile(this.assignee[ii].accountId);
    }
    this.displayAssignee = !((this.assignee.length===1 && this.assignee[0].accountId===FwDatas.getUser().accountId));
    
    if(this.dueDate){
      this.start = this.end = this.endDate = this.startDate = this.dueDate;
      this.isodueDate = this.dueDate.toISOString();
      if(this.recurrencyDescriptor.rrule){
        let 
          occurencies = this.listInterval({start:new Date(0),end:new Date()},1),
          mainOccurence = occurencies.filter(t=>t.maintask ||t.computedComplete===false)[0];
        
        if(mainOccurence){
          this.computedComplete = mainOccurence.computedComplete;
          this.computedDueDate = mainOccurence.computedDueDate;
          this.overDue = mainOccurence.overDue;
        }else{
          //FIXME understand it should never happen
          this.computedComplete = this.complete;
          this.computedDueDate = this.dueDate;
          this.overDue = !this.computedComplete && this.computedDueDate<new Date();
        }
      }else{
        this.computedComplete = this.complete;
        this.computedDueDate = this.dueDate;
        this.overDue = !this.computedComplete && this.computedDueDate<new Date();
      }
      
      
    }else{
      this.computedComplete = this.complete;
      this.isodueDate = "$empty";
    }
  },
  category : function(){
    if(this.taskCategoryId){
      return FwDatas.get(this.taskCategoryId);
    }
  },
  subLine:function(){
    let items = [];
    if(this.dueDate){
      items.push(Icons.task.ic_list_item_attribute_tiny_due_date.asIcon()+' '+deltatime.html(this.computedDueDate||this.dueDate,'deltaday'));
      if(this.recurrencyDescriptor.rrule){
        items[items.length-1] += ' '+Icons.task.ic_list_item_attribute_tiny_repeat.asIcon()
      }
    }
    if(this.refId && this.refObject()){
      items.push(Icons.task.ic_list_item_attribute_tiny_recipe.asIcon()+' '+this.refObject().name);
    }
    if(this.assignee.length){
      let str = Icons.task.ic_list_item_attribute_tiny_assignee.asIcon()+' ';
      if(this.assignee.length>4){
        str += this.assignee.slice(0,3).map(ass=>Html.escape(ass.name)).join(', ') + "& "+i18n.get("task_details.Nothers",(this.assignee.length-3));
      }else{
        str += this.assignee.map(ass=>Html.escape(ass.name)).join(', ');
      }
      items.push(str);
    }
    if(this.description){
      let desc = Icons.task.ic_list_item_attribute_note.asIcon()+' ';
      desc += '<span style="vertical-align:middle">'+Html.escape((this.description).replace(/\s+/g,' ').trim())+"</span>";//i18n.get('mp.description');// '<i style="max-width:30%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">'+Html.escape(this.description)+'</i>';
      items.push(desc);
    }
    return items.join(' • ')
  },
  refObject(){
    return FwDatas.get(this.refId)
  }
});




const TaskCache = new SyncCache<ApiServer.types.TaskBean>(ApiServer.tasksync,(a,b)=>{
  return b.sortingIndex-a.sortingIndex;
});
const TaskCategoryCache = new SyncCache<ApiServer.types.TaskCategorySyncBean>(ApiServer.taskcategorysync);
const TaskListCache = new ListCache<ApiServer.types.ITaskList>(ApiServer.taskgettasklists);

const MetaTaskCache = new MetaCache4<
  ApiServer.types.ITaskList[],
  ApiServer.types.TaskCategorySyncBean[],
  ApiServer.types.TaskBean[],
  ApiServer.types.RecipeBean[]
  >(function(lists,categoryList,tasks,recipes){
    lists.forEach(list=>{
      list.dispatchTasks()
    })
  },TaskListCache,TaskCategoryCache,TaskCache,recipeSyncCache);

//callback should take lists,listsById tasks as parameters
ApiServer.loadTaskAndList = async function(callback){
  //if(typeof callback==='string') console.log(new Error())
  //recipe are needed by some tasks (added in Shopping from recipe)
  var [lists,categoryList,tasks,recipes] = await MetaTaskCache.refresh();
  
  var listsById = {},tasksById = {};
  tasks.forEach(task=>tasksById[task.metaId] = task)
  lists.forEach(list=>listsById[list.metaId] = list)
  
  amplify.publish("taskRefreshed",lists,listsById,tasks,tasksById,categoryList);
  if(callback){
    callback(lists,listsById,tasks,tasksById,categoryList);
  }
}
amplify.subscribe("taskNeedRefresh",ApiServer.loadTaskAndList)
 
export {MetaTaskCache,TaskCache,TaskCategoryCache,TaskListCache}  